import { render, staticRenderFns } from "./InstanceTable.vue?vue&type=template&id=88b18e50&"
import script from "./InstanceTable.vue?vue&type=script&lang=js&"
export * from "./InstanceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports